// Actions
export const SET_ORDER_LIST = 'ORDER_STATUS/SET_ORDER_LIST'
export const SET_ORDER = 'ORDER_STATUS/SET_ORDER'
export const SET_ORDER_NUMBER = 'ORDER_STATUS/SET_ORDER_NUMBER'
export const SET_PREMIUM_DELIVERY = 'ORDER_STATUS/SET_PREMIUM_DELIVERY'
export const SET_PREMIUM_CHARGE = 'ORDER_STATUS/SET_PREMIUM_CHARGE'

// Action Creators
export function setOrderList(orderList) {
  return { type: SET_ORDER_LIST, payload: orderList }
}

export function setOrder(order) {
  return { type: SET_ORDER, payload: order }
}

export function setOrderNumber(orderNumber) {
  return { type: SET_ORDER_NUMBER, payload: orderNumber }
}

export function setPremiumDelivery(premiumDelivery) {
  return { type: SET_PREMIUM_DELIVERY, payload: premiumDelivery }
}

export function setPremiumDeliveryCharge(charge) {
  return { type: SET_PREMIUM_CHARGE, payload: charge }
}

// Reducer
const initialState = {
  order: {},
  orderNumber: '',
  orderList: [],
  premiumDelivery: false,
  premiumDeliveryCharge: {},
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ORDER_LIST:
      return { ...state, orderList: payload }
    case SET_ORDER:
      return { ...state, order: payload }
    case SET_ORDER_NUMBER:
      return { ...state, orderNumber: payload }
    case SET_PREMIUM_DELIVERY:
      return { ...state, premiumDelivery: payload }
    case SET_PREMIUM_CHARGE:
      return { ...state, premiumDeliveryCharge: payload }
    default:
      return state
  }
}
